module.exports = __webpack_public_path__ + "img/oee2.9fdac55e.svg";